import { FC } from 'react';
import { FundSelectionContext, GrossIRRContext, TasksProgressContext } from './FirmSummaryAsyncCells.contexts';
import { FirmSummaryAsyncDataProviderProps } from './types';

/**
 * Supplies the firm summary grid's late-arriving values to the cells that render them.
 *
 * These used to be parser inputs, which meant every one of them rebuilt the SpreadsheetConfig
 * (and so re-evaluated the whole workbook) the moment its request resolved. Passing them
 * through context instead lets the sheet be built once from the definition data while each
 * cell fills itself in.
 */
const FirmSummaryAsyncDataProvider: FC<FirmSummaryAsyncDataProviderProps> = ({
  children,
  fundSelection,
  grossIRR,
  tasksProgress,
}) => (
  <GrossIRRContext.Provider value={grossIRR}>
    <TasksProgressContext.Provider value={tasksProgress}>
      <FundSelectionContext.Provider value={fundSelection}>{children}</FundSelectionContext.Provider>
    </TasksProgressContext.Provider>
  </GrossIRRContext.Provider>
);

export default FirmSummaryAsyncDataProvider;
